import React from 'react';
import moment from 'moment';
import { ReactComponent as Ticket } from '../../../../../../resources/images/svg/ticket.svg';
import { ReactComponent as CircleArrow } from '../../../../../../resources/images/svg/circeldArrow.svg';
import { ReactComponent as Location } from '../../../../../../resources/images/svg/location.svg';
import useTranslation from '../../../../../hooks/translation/useTranslation';

function TicketRideInfo({ data, isExpired }) {
  const { currentLanguage } = useTranslation();
  return (
    <>
      <div className="flex gap-3 items-center h-9">
        <Ticket className={isExpired ? 'fill-gray-gr' : 'fill-green-gr'} />
        <p className="m-0 text-base">{data[0]?.statement?.statement_id}</p>
        <p className="m-0 text-base">{data[0]?.train_number}</p>
      </div>
      <div className="flex items-start gap-3">
        <CircleArrow className="w-5" />
        <p className="m-0 flex-1 text-base">
          {data[0]?.ticket_start_station?.[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || data[0]?.ticket_start_station?.name_ka}
        </p>
        <p className="m-0 flex-1 text-base">
          {moment(data[0]?.departure_date).format('DD.MM.YYYY')}
          <br />
          {moment(data[0]?.departure_date).format('HH:mm')}
        </p>
      </div>
      <div className="flex items-start gap-3">
        <Location className="w-5" />
        <p className="m-0 flex-1 text-base">
          {data[0]?.ticket_end_station?.[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || data[0]?.ticket_end_station?.name_ka}
        </p>
        <p className="m-0 flex-1 text-base">
          {moment(data[0]?.arrival_date).format('DD.MM.YYYY')}
          <br />
          {moment(data[0]?.arrival_date).format('HH:mm')}
        </p>
      </div>
    </>
  );
}

export default TicketRideInfo;
